export const toInt = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const parseIfoodError = (error, fallbackMessage) => {
    const errorData = error?.response?.data?.data || {};
    const message = errorData.errorMessage || error?.response?.data?.message || fallbackMessage;
    const entityId = errorData.entityId;

    return entityId ? `${message} (${entityId})` : message;
};

export const extractProductIdsFromSubCategories = (subCategoryIds = [], allSubCategories = [], acc = new Set()) => {
    subCategoryIds.forEach((subId) => {
        const subCategory = allSubCategories.find((item) => item.id === subId);
        if (!subCategory) return;

        (subCategory.products || []).forEach((productId) => acc.add(productId));
        if (subCategory.subCategories?.length) {
            extractProductIdsFromSubCategories(subCategory.subCategories, allSubCategories, acc);
        }
    });

    return acc;
};
